import { IoClose } from "react-icons/io5";
import KitchenCategory from "./KitchenCategory";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import PageStatus from "../../../PageStatus/PageStatus";

const KitchenSummarySidebar = ({
    handleSidebar,
    categories,
    categoryVoid,
    sidebarLoading,
    sidebarError,
}) => {
    return (
        <div>
            <button
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasWithBothOptions"
                aria-controls="offcanvasWithBothOptions"
                onClick={handleSidebar}
                className="
                    inline-flex items-center justify-center gap-1.5
                    px-3 py-2
                    rounded-md
                    font-semibold
                    border border-[#E0DDD8]
                    bg-white
                    text-[#2C2C2A]
                    text-xs
                    hover:bg-[#F3F1EC]
                    transition-al
                    w-full
                "
            >
                <HiOutlineClipboardDocumentList className="w-4 h-4" />
                <span>Item Summary</span>
            </button>

            <div
                className="offcanvas offcanvas-end"
                data-bs-scroll="true"
                tabIndex="-1"
                id="offcanvasWithBothOptions"
                aria-labelledby="offcanvasWithBothOptionsLabel"
            >
                <div className="bg-white h-screen flex flex-col">
                    <div className="bg-[#F8F7F3] border-b border-[#E0DDD8] px-6 py-2.5 flex justify-between items-center">
                        <div
                            id="offcanvasWithBothOptionsLabel"
                            className="text-base font-semibold text-[#2C2C2A] m-0"
                        >
                            Cooked Item Summary
                        </div>

                        <button
                            type="button"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                            className="
                                p-1.5
                                rounded-lg
                                border border-[#E0DDD8]
                                bg-white
                                text-[#6B6862]
                                hover:bg-[#F3F1EC]
                                hover:text-[#2C2C2A]
                                transition-all duration-200
                                active:scale-95
                            "
                        >
                            <IoClose size={14} />
                        </button>
                    </div>

                    <PageStatus
                        loading={sidebarLoading}
                        error={sidebarError}
                        loadingText="Loading item summary..."
                    />

                    {!sidebarLoading && !sidebarError && (
                        <div className="offcanvas-body bg-white px-4 py-2.5 tiny-scrollbar overflow-y-auto">
                            <KitchenCategory
                                categories={categories}
                                categoryVoid={categoryVoid}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default KitchenSummarySidebar;